import "./modules/common";
import Vue from "vue";
import VSelect from "vue-select";
import WebAccount, { MyAchievements } from "spiritweb.packages.web-account";
import { BasketResource } from "spiritweb.packages.ecommerce";
import VueApp from "~/Scripts/new/vueApp";
import YourDetailsForm from "~/Components/Accounts/YourDetailsForm.vue";
import LogOutButton from "~/Components/Accounts/LogoutButton.vue";
import LoginForm from "~/Components/Accounts/LoginForm.vue";
import MyWishlists from "~/Components/Accounts/MyWishlists.vue";
import MyCourses from "~/Components/Accounts/Courses/MyCourses.vue";
import DigitalResources from "~/Components/Accounts/DigitalResources.vue";
import MyOrders from "~/Components/Accounts/MyOrders.vue";
import MyQuotes from "~/Components/Accounts/MyQuotes.vue";
import idPlugin from "~/Scripts/plugins/idPlugin";
import store from "~/Scripts/store";
import LoadingSpinner from "~/Components/LoadingSpinner.vue";

Vue.use( WebAccount, { store } );
Vue.use( idPlugin );

new VueApp( {
  name: "MyAccount",
  components: {
    YourDetailsForm,
    LogOutButton,
    LoginForm,
    VSelect,
    MyWishlists,
    MyCourses,
    DigitalResources,
    MyOrders,
    MyQuotes,
    MyAchievements,
    LoadingSpinner
  },
  data: () => ( {
    selectedTab: null,
    activeTab: "details",
    hasQuotes: false,
    newOrderId: null,

    /**
     * My events export fields and formatting
     */
    exportFields: [
      {
        key: "eventTitle",
        label: "Event"
      },
      {
        key: "marketingLocation",
        label: "Location"
      },
      {
        key: "startDate",
        label: "Start date",
        type: "date"
      },
      {
        key: "endDate",
        label: "End date",
        type: "date"
      },
      {
        key: "sessions",
        label: "Sessions"
      },
      {
        key: "bookingReference",
        label: "Booking ref."
      },
      {
        key: "orderReference",
        label: "Order ref."
      },
      {
        key: "delegateFirstName",
        label: "First name"
      },
      {
        key: "delegateLastName",
        label: "Last name"
      }
    ]
  } ),
  computed: {
    knownTabs () {
      const result = [
        {
          id: "details",
          label: "My details"
        },
        {
          id: "wishlists",
          label: "My wish lists"
        },
        {
          id: "orders",
          label: "Order history"
        },
        // {
        //   id: "addresses",
        //   label: "Address book"
        // },
        {
          id: "resources",
          label: "My digital resources"
        },
        {
          id: "my-subscriptions-content",
          label: "My subscription content"
        },
        {
          id: "events",
          label: "My events"
        },
        {
          id: "courses",
          label: "My online courses"
        },
        {
          id: "certificates",
          label: "My certificates"
        }
        // {
        //   id: "training",
        //   label: "Training & CPD"
        // },
      ];

      if ( this.hasQuotes ) {
        result.splice( 1, 0, {
          id: "quotes",
          label: "My quotes"
        } );
      }

      return result;
    }
  },
  watch: {
    activeTab: {
      immediate: true,
      handler ( val ) {
        const match = this.knownTabs.find( x => x.id === val );
        if ( match ) {
          this.selectedTab = match;
        }
      }
    },
    selectedTab: {
      deep: true,
      handler ( val ) {
        if ( val ) {
          this.activeTab = val.id;
        }
      }
    }
  },
  created () {
    window.addEventListener( "hashchange", this.onHashChange, false );

    BasketResource.getId().then( response => {
      if ( response && response.data ) {
        this.newOrderId = response.data;
        console.log( this.newOrderId );
      }
    } );
  },
  mounted () {
    const enableQuotes = document.querySelector( "[name='EnableMyAccountQuotes']" );
    if ( enableQuotes ) {
      this.hasQuotes = true;
    }

    this.onHashChange();
  },
  beforeDestroy () {
    window.removeEventListener( "hashchange", this.onHashChange );
  },
  methods: {
    onHashChange () {
      const { hash } = window.location;
      const route = this.getRoute( hash );

      if ( this.knownTabs.some( x => x.id === route.tab ) ) {
        this.activeTab = route.tab;
      }
    },
    getRoute ( hash ) {
      let result = {};

      if ( hash ) {
        result = {
          tab: hash.replace( "#", "" )
        };
      }

      return result;
    }
  }
} );
